import { Deadline } from '../../types';
import './DeadlineCard.css';

function DeadlineCard(deadline: Deadline) {
    return (
        <div className="deadline">
            <div className="icon">
                <i className={deadline.icon}></i>
            </div>
            <div className="info">
                <h3>{deadline.name}</h3>
                <p>Due: {deadline.date}</p>
            </div>
        </div>
    );
}

export default DeadlineCard;